import React from "react";
import cls from "../style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage, useIntl } from "react-intl";
import { useCallback } from "react";
import { useMemo } from "react";
import { unitPrice } from "../../../../../../../../../utils/product";
import { 
    TOTAL_STATUS_UNPAID, 
    TOTAL_STATUS_SHIPPED, 
    TOTAL_STATUS_REVIEW, 
    TOTAL_STATUS_CANCELED
} from '../../../../../../utils/constant'
import { Link, useHistory } from "react-router-dom";
import CountDown from "../../../../../../../../components/count-down/index";
import { addToCarts } from "../../../../../../../../../api";
import Toast from "../../../../../../../../components/toast";
import Alert from "../../../../../../../../components/alert";
import { action_fetch_cart_count } from "../../../../../../../../../store/actions/global";
import { useDispatch } from "react-redux";
import { useOrder } from "../../../../../../hook/order";
import { setCustomerLoading, setSuccessReminder } from "../../../../../../../../../store/actions/pages/customer";
import ConfigConfirm from "../../../../../../../../components/alert/config-confirm";
import { fetchConfirmOrder } from "../../../../../../../../../api";
import { action_fetch_order_list_shipped, action_fetch_order_list_all, action_fetch_order_list_confirmed } from "../../../../../../../../../store/actions/pages/customer";
import { useSelector } from "react-redux";
import OrderItemProductImages from '../fragments/product-images/index';
import OrderItemPrices from "../fragments/order-item-prices";
import { action_fetch_order_detail } from "../../../../../../../../../store/actions/pages/customer";

export const OrderStatusBtnLink = props =>{
    useStyles(cls);
    const { orderItem, isDetail } = props;
    const Intl = useIntl();
    const dispatch = useDispatch();
    const history = useHistory();
    const { getBtnText, getPayUrl, orderOffset, getBtnText2 } = useOrder(orderItem);
    const pageCustomer = useSelector(state =>state.pageCustomer);

    const confirmHandle = useCallback(async (orderId) =>{
        // Alert Modal 
        ConfigConfirm({
            message:{
                text:Intl.formatMessage({ id: "order_confirmed_enter_message", defaultMessage: "The item (s) is still in transit, are you sure you want to click confirm to receive it?" }),
            },
            btn1:{
                clickHandle:async () =>{
                    dispatch(setCustomerLoading(true));
                    let response = await fetchConfirmOrder(orderId);
                    // 在订单详情的时候刷新一次详情信息
                    if(isDetail){
                        await dispatch(action_fetch_order_detail(orderId));
                    }
                    dispatch(setCustomerLoading(false));
                    if(response?.code === 200){
                        dispatch(setSuccessReminder({
                            commonData:{
                                templateStr: response?.prompt?.html,
                                orderId: orderId,
                            },
                            detailReminder:{
                                title: Intl.formatMessage({ id: "order_confirm_success", defaultMessage: "Order Confirmed Successfully!" }),
                                font: Intl.formatMessage({ id: "order_detail_view", defaultMessage: "You can view order details to check this order." }),
                                btns:[
                                    {
                                        name: Intl.formatMessage({ id: "view_order", defaultMessage: "View Order" }),
                                        href: `/user/order/detail/${orderId}`,
                                        isReplace: isDetail
                                    },
                                    {
                                        name: Intl.formatMessage({ id: "to_review", defaultMessage: "To Review" }),
                                        href: '/user/order/confirmed'
                                    }
                                ]
                            }
                        }));
    
                        // 需要判断是否有值再进行一次初始化 因为如果你没有进入过这个list初始化会重复
                        if(pageCustomer?.orderListAll?.data?.length > 0){
                            dispatch(action_fetch_order_list_all(true));
                        }
    
                        if(pageCustomer?.orderListShipped?.data?.length > 0){
                            dispatch(action_fetch_order_list_shipped(true));
                        }
    
                        if(pageCustomer?.orderListConfirmed?.data?.length > 0){
                            dispatch(action_fetch_order_list_confirmed(true));
                        }
                    }else{
                        response?.result && Alert(response.result);
                    }
                }
            },
            btn2:{}
        });
    }, [pageCustomer, isDetail]);

    const addProducts = useCallback(async (products, orderId) =>{
        let params = products?.map(product =>({"variantId":product.variantId,"quantity":'1'}));
        let response = await addToCarts(params);
        if(response?.code === 200){
            Toast(Intl.formatMessage({ id: "add_success", defaultMessage: "Add Success" }));
            
            dispatch(setSuccessReminder({
                commonData:{
                    orderId: orderId,
                    showHeader:true
                },
                detailReminder:{
                    title: Intl.formatMessage({ id: "add_to_bag_success", defaultMessage: "Add to Bag Successfully!" }),
                    btns:[
                        {
                            name: Intl.formatMessage({ id: "view_bag", defaultMessage: "View Bag" }),
                            href: `/cart`,
                            type: "href"
                        }
                    ]
                }
            }));
            dispatch(action_fetch_cart_count());
        }else{
            Alert(response?.result || Intl.formatMessage({ id: "add_failed", defaultMessage: "Add Failed" }));
        }
    }, []);

    const trackDifference = useCallback((evt) =>{
        evt.preventDefault();
        const { currentTarget } = evt;
        if(isDetail){
            let packages = orderItem?.logistics?.packages?.[0];
            if(packages?.logisticsSupplierWebsiteURL){
                window.location.href = packages.logisticsSupplierWebsiteURL;
            }else{
                history.push(currentTarget?.getAttribute('href'));
            }
        }else{
            history.push(currentTarget?.getAttribute('href'));
        }
    }, [isDetail, orderItem]);

    const toReviewHandle = useCallback((evt, orderId) =>{
        evt.preventDefault();
        const { currentTarget } = evt;

        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: 'Order Review',
                orderId:orderId
            })
        }
        history.push(currentTarget?.getAttribute('href'));
    }, []);


    return <div className={cls.OrderStatusBtnLink}>
        {/* 状态:status  Processing:2  Shipped:3 */}
        {
            orderItem?.fulfillmentStatus !== TOTAL_STATUS_UNPAID && <a href={`/user/order/tracking/${orderItem?.id}`} className={cls.LinkBtn} onClick={trackDifference}>
                <FormattedMessage id="track" defaultMessage="Track" />
            </a>
        }
        
        {
            orderItem?.isConfirmBtnShow && orderItem?.fulfillmentStatus === TOTAL_STATUS_SHIPPED && <React.Fragment>
                <a 
                    className={cls.LinkBtn} 
                    onClick={() =>confirmHandle(orderItem.id)}
                >   
                    <FormattedMessage id="confirm" defaultMessage="confirm" />
                </a>
            </React.Fragment>
        }

        {
            getPayUrl && orderItem?.fulfillmentStatus === TOTAL_STATUS_UNPAID && <React.Fragment>
                <a 
                    href={getPayUrl} 
                    className={cls.LinkBtn} 
                    target="_blank" 

                >
                    {getBtnText}
                    {
                        orderOffset > 1000 && <React.Fragment>
                            {/* {
                                只有线下支付有未付款订单所以直接改成通用的
                                getBtnText === 'Imprimir boleto' && <div className={cls.TimeLeft}>
                                    <span className={cls.Font}>Presente de cupão expirs: </span>
                                    
                                    <CountDown 
                                        offset={orderOffset} 
                                        showHour 
                                        showLabel
                                    />
                                </div>
                            }

                            {
                                (getBtnText==='Generar Ticket' || getBtnText==='Gerar Ticket') && <div className={cls.TimeLeft}>
                                    <span className={cls.Font}>Tiempo restante para realizar el pago: </span>
                                    
                                    <CountDown 
                                        offset={orderOffset} 
                                        showHour 
                                        showLabel
                                    />
                                </div>
                            } */}

                            <div className={cls.TimeLeft}>
                                <span className={cls.Font}><FormattedMessage id="remaining" defaultMessage="Remaining Payment Time" />: </span>
                                
                                <CountDown 
                                    offset={orderOffset} 
                                    showHour 
                                    showDay
                                    showLabel
                                />
                            </div>
                        </React.Fragment>
                    }
                </a>
            </React.Fragment>
        }

        {
            !getPayUrl && orderItem?.fulfillmentStatus === TOTAL_STATUS_UNPAID && orderOffset > 1000 && <React.Fragment>
                <a 
                    href={`/checkout/${orderItem?.id}`} 
                    className={cls.LinkBtn} 

                >
                    <FormattedMessage id="pay_now" defaultMessage="PAY NOW" />

                    <div className={cls.TimeLeft}>
                        <span className={cls.Font}><FormattedMessage id="remaining" defaultMessage="Remaining Payment Time" />: </span>
                        
                        <CountDown 
                            offset={orderOffset} 
                            showHour 
                            showDay
                            showLabel
                        />
                    </div>
                </a>
            </React.Fragment>
        }

        {
            orderItem?.fulfillmentStatus===TOTAL_STATUS_REVIEW  && <React.Fragment>
                <a className={cls.LinkBtn} href={`/user/order/review/${orderItem?.id}`} onClick={(evt) =>toReviewHandle(evt, orderItem?.id)}><FormattedMessage id="to_review" defaultMessage="To Review" /></a>
            </React.Fragment>
        }

        {
            ((isDetail && orderItem?.fulfillmentStatus===TOTAL_STATUS_CANCELED) || orderItem?.fulfillmentStatus===TOTAL_STATUS_REVIEW)  && <React.Fragment>
                {
                    orderItem?.orderItems && <a 
                        className={cls.LinkBtn} 
                        onClick={()=>addProducts(orderItem.orderItems, orderItem?.id)}
                    >
                        <FormattedMessage id="repurchase" defaultMessage="Repurchase" />
                    </a>
                }
            </React.Fragment>
        }

        {
            isDetail && <React.Fragment>
                {
                    getPayUrl && getBtnText && getBtnText2 && orderItem?.fulfillmentStatus === TOTAL_STATUS_UNPAID && orderOffset > 1000 && <React.Fragment>
                        <a 
                            href={`/checkout/${orderItem?.id}`} 
                            className={cls.LinkBtn} 
                        >
                            {getBtnText2}
                        </a>
                    </React.Fragment>
                }
            </React.Fragment>
        }
    </div>
}

export default props =>{
    useStyles(cls);
    const { orderItem } = props;

    return <div className={cls.OrderListItem}>
        <div className={cls.Hd}>
            <div className={cls.OrderNoStatus}>
                <span><FormattedMessage id="order_no" defaultMessage="Order No" />:{orderItem.id}</span>

                <span>{orderItem.fulfillmentStatusView}</span>
            </div>
        </div>

        <div className={cls.PaddingContainer}>
            <OrderItemProductImages orderItem={orderItem} orderProducts={orderItem?.orderItems} />

            <OrderItemPrices orderItem={orderItem} orderProducts={orderItem?.orderItems} priceTotal={orderItem?.orderTotal} />

            <OrderStatusBtnLink orderItem={orderItem} />
        </div>
    </div>
}